<script>
import {
  agentRegistrationComputed,
  agentRegistrationMethods,
} from '@state/helpers/agent-registration'
import { STATUS_REQUEST } from '@utils/constant'
import cloneDeep from 'lodash/cloneDeep'
import registrationItems from './registrationItems'

export default {
  page: {
    title: 'Registration Agent',
    meta: [{ name: 'description', content: 'The Registration Agent page.' }],
  },
  data() {
    return {
      items: null,
      title: this.$t('pages.agentRegistration'),
    }
  },
  computed: {
    ...agentRegistrationComputed,
    errorServerSideComputed() {
      return this.getErrors
    },
  },
  watch: {
    // watch status request api
    getStatus() {
      // if register success back to agent list page
      if (this.getStatus === STATUS_REQUEST.SUCCESS) {
        this.resetRegistrationAgent()
        this.backToListPage()
      }
    },
  },
  mounted() {
    this.initItems()
  },
  methods: {
    ...agentRegistrationMethods,
    initItems() {
      this.items = cloneDeep(registrationItems)
    },
    handleAddNewAgent() {
      const payload = this.items.reduce((results, item) => {
        results[item.key] = item.value
        return results
      }, {})
      this.registrationAgent(payload)
    },
    handleCancel() {
      this.initItems()
      this.backToListPage()
    },
    backToListPage() {
      this.$router.push({ name: 'agentList' })
    },
    isRequiredPassword(data) {
      return !(data.trim() === '' && data.length > 0)
    },
    isComfirmedPassword(key) {
      const field = {
        passwordConfirm: 6,
        password: 5,
      }
      if (this.items[field[key]].value === '') {
        return false
      } else {
        return key
      }
    },
  },
}
</script>

<template>
  <BaseAddNewCard
    :errors="errorServerSideComputed"
    type="add"
    @submit="handleAddNewAgent"
    @cancel="handleCancel"
  >
    <template v-slot:header>
      <h5 class="card-title">{{ title }}</h5>
    </template>
    <template v-slot>
      <CRow v-for="item in items" :key="item.key">
        <CCol sm="3">
          {{ $t(`fields.${item.label}`) }}
          <span v-if="item.rules" class="text-danger">*</span>
        </CCol>
        <CCol sm="9">
          <BaseInput
            v-if="item.as === 'input' && item.key === 'password'"
            v-model="item.value"
            :rules="{
              required: isRequiredPassword(item.value),
              password: true,
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseInput
            v-else-if="item.as === 'input' && item.key === 'password_2'"
            v-model="item.value"
            :rules="{
              required: isRequiredPassword(item.value),
              password: true,
              confirmed: isComfirmedPassword('password'),
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseInput
            v-else-if="item.as === 'input'"
            v-model="item.value"
            :rules="item.rules"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseTextarea
            v-else
            v-model="item.value"
            :rules="item.rules"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="off"
          />
        </CCol>
      </CRow>
    </template>
  </BaseAddNewCard>
</template>

<style lang="scss" scoped>
.card-title {
  margin-bottom: 0 !important;
  font-weight: 600;
  color: #73818f;
}
</style>
